import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../utils/processAction";
import { actionTypes as userActionTypes } from "./reducer";
import {
  getUsers as getUsersService,
  getSingleUser as getSingleUserService,
  getClients as getClientsService,
  inviteUser as inviteUserService,
  registerUser as registerUserService,
  updateUser as updateUserService,
  deleteUser as deleteUserService,
  deleteProfile as deleteProfileService,
  reInviteUser as reInviteUserService,
  updateUserStatus as updateUserStatusService,
} from "./service";

function* getUsers({ params }) {
  yield processAction({
    params: { params },
    service: getUsersService,
    success: userActionTypes.GET_USERS_SUCCESS,
    failed: userActionTypes.GET_USERS_FAILED
  })
}

function* getSingleUser({ params }) {
  yield processAction({
    params: { params },
    service: getSingleUserService,
    success: userActionTypes.GET_SINGLE_USER_SUCCESS,
    failed: userActionTypes.GET_SINGLE_USER_FAILED
  })
}

function* getClients({ params }) {
  yield processAction({
    params: { params },
    service: getClientsService,
    success: userActionTypes.GET_CLIENTS_SUCCESS,
    failed: userActionTypes.GET_CLIENTS_FAILED
  })
}

function* inviteUser({ body }) {
  yield processAction({
    params: { body },
    service: inviteUserService,
    success: userActionTypes.INVITE_USER_SUCCESS,
    failed: userActionTypes.INVITE_USER_FAILED
  })
}

function* registerUser({ body }) {
  yield processAction({
    params: { body },
    service: registerUserService,
    success: userActionTypes.REGISTER_USER_SUCCESS,
    failed: userActionTypes.REGISTER_USER_FAILED
  })
}

function* updateUser({ id, body }) {
  yield processAction({
    params: { id, body },
    service: updateUserService,
    success: userActionTypes.UPDATE_USER_SUCCESS,
    failed: userActionTypes.UPDATE_USER_FAILED
  })
}

function* deleteUser({ id }) {
  yield processAction({
    params: { id },
    service: deleteUserService,
    success: userActionTypes.DELETE_USER_SUCCESS,
    failed: userActionTypes.DELETE_USER_FAILED
  })
}

function* deleteProfile({ body, id }) {
  yield processAction({
    params: { body, id },
    service: deleteProfileService,
    success: userActionTypes.DELETE_PROFILE_SUCCESS,
    failed: userActionTypes.DELETE_PROFILE_FAILED
  })
}

function* reInviteUser({ body }) {
  yield processAction({
    params: { body },
    service: reInviteUserService,
    success: userActionTypes.REINVITE_USER_SUCCESS,
    failed: userActionTypes.REINVITE_USER_FAILED
  })
}

function* updateUserStatus({ id, body }) {
  yield processAction({
    params: { id, body },
    service: updateUserStatusService,
    success: userActionTypes.UPDATE_USER_STATUS_SUCCESS,
    failed: userActionTypes.UPDATE_USER_STATUS_FAILED
  })
}

function* watchUsers() {
  yield all([
    takeLatest(userActionTypes.GET_USERS, getUsers),
    takeLatest(userActionTypes.GET_SINGLE_USER, getSingleUser),
    takeLatest(userActionTypes.GET_CLIENTS, getClients),
    takeLatest(userActionTypes.REGISTER_USER, registerUser),
    takeLatest(userActionTypes.INVITE_USER, inviteUser),
    takeLatest(userActionTypes.UPDATE_USER, updateUser),
    takeLatest(userActionTypes.DELETE_USER, deleteUser),
    takeLatest(userActionTypes.DELETE_PROFILE, deleteProfile),
    takeLatest(userActionTypes.REINVITE_USER, reInviteUser),
    takeLatest(userActionTypes.UPDATE_USER_STATUS, updateUserStatus)
  ])
}

export default [watchUsers()]




// WEBPACK FOOTER //
// ./src/modules/user/saga.js